(() => {
  const initCopyUrl = () => {
    const copyButtons = document.querySelectorAll('.js-copy-url');

    if (!copyButtons.length) {
      return;
    }

    copyButtons.forEach((copyButton) => {
      const copyText = copyButton.querySelector('span');
      const defaultText = copyText ? copyText.textContent : '';

      const changeText = (text) => {
        if (!copyText) {
          return;
        }

        copyText.textContent = text;
      };

      const resetText = () => {
        if (!copyText) {
          return;
        }

        setTimeout(() => {
          copyText.textContent = defaultText;
        }, 2000);
      };

      copyButton.addEventListener('click', async () => {
        const currentUrl = window.location.href;

        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(currentUrl);
          } else {
            const textarea = document.createElement('textarea');
            textarea.value = currentUrl;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'fixed';
            textarea.style.top = '0';
            textarea.style.left = '-9999px';

            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
          }

          changeText('コピーしました');
          resetText();
        } catch (error) {
          changeText('コピーに失敗しました');
          resetText();
        }
      });
    });
  };

  const initSwiper = () => {
    if (typeof Swiper === 'undefined') {
      return;
    }

    const breakpoint = window.matchMedia('(max-width: 1020px)');
    let otherSwiper = null;

    const initGallerySwiper = () => {
      const mainEl = document.querySelector('.js-property-main-swiper');
      const thumbEl = document.querySelector('.js-property-thumb-swiper');

      if (!mainEl) {
        return;
      }

      const mainSlides = mainEl.querySelectorAll('.swiper-slide');
      const slideCount = mainSlides.length;

      if (slideCount <= 0) {
        return;
      }

      const canUseThumb = thumbEl && slideCount > 1;
      const canLoop = slideCount >= 4;

      let thumbSwiper = null;

      if (canUseThumb) {
        thumbSwiper = new Swiper(thumbEl, {
          slidesPerView: 'auto',
          spaceBetween: 4,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
        });
      }

      const mainSwiperOptions = {
        loop: canLoop,
        centeredSlides: true,
        slidesPerView: 'auto',
        spaceBetween: 0,
        speed: 600,
        allowTouchMove: slideCount > 1,
        breakpoints: {
          1021: {
            spaceBetween: 40,
          },
        },
      };

      if (thumbSwiper) {
        mainSwiperOptions.thumbs = {
          swiper: thumbSwiper,
        };
      }

      if (slideCount > 1) {
        mainSwiperOptions.navigation = {
          nextEl: '.js-property-main-swiper-next',
          prevEl: '.js-property-main-swiper-prev',
        };
      }

      new Swiper(mainEl, mainSwiperOptions);
    };

    const initOtherSwiper = () => {
      const otherEl = document.querySelector('.js-property-other-swiper');

      if (!otherEl) {
        return;
      }

      if (breakpoint.matches) {
        if (otherSwiper) {
          return;
        }

        otherSwiper = new Swiper(otherEl, {
          loop: false,
          slidesPerView: 1.15,
          spaceBetween: 16,
          centeredSlides: true,
          speed: 600,
          pagination: {
            el: '.js-property-other-pagination',
            clickable: true,
          },
        });

        return;
      }

      if (otherSwiper) {
        otherSwiper.destroy(true, true);
        otherSwiper = null;
      }
    };

    const initRecentlySwiper = () => {
      const recentlyEl = document.querySelector('.js-property-recently-swiper');

      if (!recentlyEl) {
        return;
      }

      new Swiper(recentlyEl, {
        loop: false,
        speed: 600,
        slidesPerView: 1.15,
        spaceBetween: 16,
        centeredSlides: true,
        navigation: {
          nextEl: '.js-property-recently-swiper-next',
          prevEl: '.js-property-recently-swiper-prev',
        },
        pagination: {
          el: '.js-property-recently-pagination',
          clickable: true,
        },
        breakpoints: {
          1021: {
            slidesPerView: 3,
            spaceBetween: 40,
            centeredSlides: false,
          },
        },
      });
    };

    initGallerySwiper();
    initOtherSwiper();
    initRecentlySwiper();

    breakpoint.addEventListener('change', () => {
      initOtherSwiper();
    });
  };

  const init = () => {
    initCopyUrl();
    initSwiper();
  };

  window.addEventListener('DOMContentLoaded', init);
})();
